// ===================================
// CONFIG API SERVICE
// src/services/configApi.js
// ===================================

import api from './api';

export const getPricing = async () => {
  return api.get('/config/pricing');
};

export const getInterviewOptions = async () => {
  return api.get('/config/interview-options');
};

export const getPhoneNumber = async (accessCode) => {
  return api.get(`/config/phone-number/${accessCode}`);
};

export const getPlatformConfig = async () => {
  return api.get('/config/platform');
};

export const getFeatures = async () => {
  return api.get('/config/features');
};

export default {
  getPricing,
  getInterviewOptions,
  getPhoneNumber,
  getPlatformConfig,
  getFeatures
};
